import { FastField, Field, type FieldProps } from 'formik'
import { type FC } from 'react'
import { InputPhone, InputPhoneSize } from '@/shared/ui/Input'

type PhoneFieldProps = {
  type?: string
  name: string
  label?: string
  placeholder?: string
  className: string
  sizeInput?: InputPhoneSize
  disabled?: boolean
  required?: boolean
  isFastField?: boolean
  defaultCountry?: string
  defaultEmpty?: boolean
  dropDownClassName?: string
}

export const PhoneField: FC<PhoneFieldProps> = props => {
  const {
    name,
    label,
    type = 'text',
    placeholder,
    sizeInput = 'medium',
    className,
    disabled,
    required,
    isFastField,
    defaultCountry,
    defaultEmpty,
    dropDownClassName,
  } = props

  if (isFastField) {
    return (
      <FastField name={name}>
        {({ field, meta, form: { setFieldValue } }: FieldProps) => (
          <div className={className}>
            <InputPhone
              {...field}
              type={type}
              sizeInput={sizeInput}
              placeholder={placeholder}
              label={label}
              setFieldValue={setFieldValue}
              disabled={disabled}
              error={meta.touched && meta.error}
              isRequired={required}
              defaultCountry={defaultCountry}
              defaultEmpty={defaultEmpty}
              dropDownClassName={dropDownClassName}
            />
          </div>
        )}
      </FastField>
    )
  }

  return (
    <Field name={name}>
      {({ field, meta, form: { setFieldValue } }: FieldProps) => (
        <div className={className}>
          <InputPhone
            {...field}
            type={type}
            placeholder={placeholder}
            label={label}
            sizeInput={sizeInput}
            disabled={disabled}
            setFieldValue={setFieldValue}
            error={meta.touched && meta.error && meta.error}
            isRequired={required}
            defaultCountry={defaultCountry}
            defaultEmpty={defaultEmpty}
            dropDownClassName={dropDownClassName}
          />
        </div>
      )}
    </Field>
  )
}
